const getStylesToUpdate = ({ backgroundImage }) => {
  if (!backgroundImage) return {};

  return {
    backgroundImage: `url("${backgroundImage}")`
  };
};

export default getStylesToUpdate;
